var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"imageLink"}},[_c('ul',[_c('li',[_c('a',{attrs:{"href":_vm.contents.content.link}},[_c('div',{staticClass:"img"},[_c('img',{staticClass:"image",attrs:{"src":_vm.image}})])])])])])}
var staticRenderFns = []

export { render, staticRenderFns }